import React from "react";
import { graphql, Script, useStaticQuery } from "gatsby";
import { schemas } from "./LD";

const ProductSEO = ({ location, data, imgUrl }) => {
  const { site, allContentfulDomain } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          defaultTitle: title
          defaultDescription: description
          siteUrl: siteUrl
        }
      }
      allContentfulDomain {
        nodes {
          title
          isoCode
          currencyCode
          url
        }
      }
    }
  `);

  function removeQueryParams(url) {
    let urlObject = new URL(url);
    urlObject.search = "";
    const newUrl = urlObject.toString();
    if (newUrl.endsWith("/")) {
      return newUrl.slice(0, -1);
    }
    return newUrl;
  }

  const { defaultTitle, defaultDescription, siteUrl } = site.siteMetadata;
  const locations = allContentfulDomain.nodes.map((marketLocation) => {
    return {
      ...marketLocation,
      canonical: removeQueryParams(marketLocation.url) + location.pathname,
    };
  });
  const seo = {
    title: data?.title || defaultTitle,
    description: data?.description || defaultDescription,
    url: `${siteUrl}${location?.pathname}`,
    defaultUrl: `https://bushbuck.com${location?.pathname}`,
    jsonSchema: data?.jsonSchema ? [...schemas, ...data.jsonSchema] : schemas,
    icon:
      data?.icon ||
      "https://cdn.shopify.com/s/files/1/0200/6190/files/Group_7a3db792-b502-4744-8cc3-cccc55e21012_32x32.png?v=1646859038",
    logo:
      data?.logo ||
      "http://cdn.shopify.com/s/files/1/0200/6190/files/Bushbuck_Logo.png?v=1627895588",
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width,initial-scale=1" />
      <meta name="theme-color" content="" />
      {seo.description && <meta name="description" content={seo.description} />}

      {seo.url && <link rel="canonical" href={seo.url} />}
      <link rel="preconnect" href="https://cdn.shopify.com" crossOrigin="" />
      {seo.icon && <link rel="icon" type="image/png" href={seo.icon} />}

      <meta property="og:site_name" content="Bushbuck" />
      {seo.url && <meta property="og:url" content={seo.url} />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      <meta property="og:type" content="website" />
      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}
      {seo.logo && <meta property="og:image" content={imgUrl ?? seo.logo} />}
      {seo.logo && (
        <meta property="og:image:secure_url" content={imgUrl ?? seo.logo} />
      )}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="628" />
      <meta name="twitter:card" content="summary_large_image" />
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}

      {seo.url && (
        <link rel="alternate" hrefLang="x-default" href={seo.defaultUrl} />
      )}
      {locations.map((location) => (
        <link
          rel="alternate"
          hrefLang={location.isoCode.toLowerCase()}
          href={location.canonical}
          key={location.isoCode}
        />
      ))}
      <script
          id="productSchema"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(seo.jsonSchema) }}
      />
    </>
  );
};

export default ProductSEO;
